/* unplugin-vue-components disabled */import { render } from "./swiper.vue?vue&type=template&id=305ec35e&scoped=true&ts=true"
import script from "./swiper.vue?vue&type=script&lang=ts"
export * from "./swiper.vue?vue&type=script&lang=ts"

import "./swiper.vue?vue&type=style&index=0&id=305ec35e&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305ec35e"],['__file',"src/baseui/swiper/swiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "305ec35e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('305ec35e', __exports__)) {
    console.log('reload')
    api.reload('305ec35e', __exports__)
  }
  
  module.hot.accept("./swiper.vue?vue&type=template&id=305ec35e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('305ec35e', render)
  })

}


export default __exports__